@if (product()?.id) {
    <app-product-price-edit-widget
        [product]="product()"
        [canDeletePriceList]="false"
        [dataTestid]="dataTestid()"
    />
} @else {
    <div
        class="flex justify-center items-center choose-ngifloader-splitter h-full w-full min-h-[400px]"
        [attr.data-testid]="'formly-product-price-edit-no-product-id-div'"
    >
        <div class="shine">
            <h3 [attr.data-testid]="'formly-product-price-edit-no-product-id-h3'">
                {{ 'product.product-choose' | translate }}
            </h3>
        </div>
    </div>
}
